import { useMutation } from '@tanstack/react-query';
import { user } from '@api/apis';
import { ResponseErrorNoticeType } from '@utils/errors';
import { Logger } from '@utils/logger';

/* Hooks */
import useNotice from '@hooks/useNotice';
import { updateContingencies } from '@store/queries/user/user.utils';

/* Utils */
import { deriveResponseError, deriveResponseStatus } from '@utils/object';
import { StatusErrors } from '@constants/base';

type TCreatePasswordProps = {
  password: string;
  rpt: string;
};
export default function useUserMutationCreatePassword() {
  const { error } = useNotice();

  return useMutation({
    mutationFn: async (payload: TCreatePasswordProps) => {
      const response = await user.createPassword(payload);

      if (StatusErrors.has(deriveResponseStatus(response)) || response.err) throw response;

      if (response.data?.user?.authToken) {
        /* This drops the cookie: silly workaround for dev: diff ports */
        await fetch(`/api/_nextassets_/current?auth_token=${response.data?.user?.authToken}`);
      }

      return response.data;
    },
    onSuccess: data => {
      const { authToken } = data.user ?? {};

      if (authToken) {
        updateContingencies(data.user);
      }
    },

    onError: (response: ResponseErrorNoticeType | Error) => {
      const err = deriveResponseError(response);

      error('There was a problem setting your password. Please re-submit your email.');
      Logger('useUserMutationResetPassword')(err?.errors);
    },
  });
}
